import dayjs from 'dayjs';
import { dateFormat } from '../contstant';

export const displayDate = (
  date?: string,
  format = dateFormat,
) => (date ? dayjs(date).format(format) : '');

export default displayDate;
